import router from './router'
import AuthMessages from './localization'

export default {
  router,
  localization: AuthMessages,
}
